import React from 'react'
import ProtectedRoute from './protected'
import QueryPage from '../pages/employee-query'

export const QueryRoutes = [
  <ProtectedRoute exact path='/query' component={QueryPage} />,
]
